'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRANSACTION_CREATED = exports.TRANSACTION_CREATED = 'TRANSACTION_CREATED';
var TRANSACTION_RECEIPTS_FETCHED = exports.TRANSACTION_RECEIPTS_FETCHED = 'TRANSACTION_RECEIPTS_FETCHED';
var TRANSACTION_RECEIPTS_FETCH_FAILED = exports.TRANSACTION_RECEIPTS_FETCH_FAILED = 'TRANSACTION_RECEIPTS_FETCH_FAILED';
var LOCAL_TRANSACTION_DISCARDED = exports.LOCAL_TRANSACTION_DISCARDED = 'LOCAL_TRANSACTION_DISCARDED';
var TRANSACTION_PROGRESS_NOTIFIED = exports.TRANSACTION_PROGRESS_NOTIFIED = 'TRANSACTION_PROGRESS_NOTIFIED';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/actionTypes.js
// module id = 465
// module chunks = 0